// ── TextButton — действие в виде ссылки («Забыли пароль?», «← Назад») ────────
// Выглядит как подчёркнутый текст, но это настоящая кнопка: работает с
// клавиатуры, и зона нажатия не меньше 32 px по высоте (невидимо — ac-hit),
// даже когда сам текст мелкий.

import { SANS } from '../themes';
import { usePalette } from './theme';

export default function TextButton({ children, onClick, tone = 'link', size = 13, bold = false, underline = true, style, C: Cp, ...rest }) {
  const C = usePalette(Cp);
  const color = tone === 'danger' ? C.danger : tone === 'muted' ? C.mid : C.blueDark;
  return (
    <button type="button" onClick={onClick} className="ac-hit"
      style={{ background: 'none', border: 'none', padding: '4px 2px', margin: '-4px -2px', color, fontFamily: SANS, fontSize: size,
        fontWeight: bold ? 700 : 500, lineHeight: 1.4, cursor: 'pointer', textDecoration: underline ? 'underline' : 'none',
        textUnderlineOffset: 2, textAlign: 'inherit', overflowWrap: 'break-word', ...style }}
      {...rest}>
      {children}
    </button>
  );
}
